'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/announce/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/scores/paths');

var loading = { loading: true };

exports.default = function (fid, state) {

  var personTotal = function personTotal(person) {
    return person.scores.map(function (s) {
      return s.value;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  if ((0, _paths.eventsWithStatusAreLoading)(state, fid, 'RES') || (0, _paths.eventsWithStatusAreLoading)(state, fid, 'RCL')) {
    return loading;
  };

  var currentEventIdOnAnnounce = (0, _paths3.currentEventIdForAnnounce)(state, fid);

  if (currentEventIdOnAnnounce && (0, _paths.participantsOfAnEventAreLoading)(state, currentEventIdOnAnnounce)) {
    return { loadingParticipants: true };
  };

  if (currentEventIdOnAnnounce && (0, _paths.eventAdjudicatorsAreLoading)(state, currentEventIdOnAnnounce)) {
    return { loadingParticipants: true };
  };

  if (currentEventIdOnAnnounce && (0, _paths.eventMedalRoundsAreLoading)(state, currentEventIdOnAnnounce)) {
    return loading;
  };

  var participants = currentEventIdOnAnnounce && (0, _paths.getParticipantsOfAnEvent)(state, currentEventIdOnAnnounce);

  var currentEvent = currentEventIdOnAnnounce && (0, _paths.getEvent)(state, currentEventIdOnAnnounce);

  var currentEventWithAdjudicators = currentEvent && currentEvent.set('adjudicators', (0, _paths2.eventAdjudicators)(state, currentEventIdOnAnnounce));

  var eventMedalRounds = currentEvent && currentEvent.get('medalRounds') && (0, _paths.getEventMedalRoundsAssociatedToAdjs)(state, currentEventIdOnAnnounce);

  var scoreSheets = currentEventWithAdjudicators && currentEventWithAdjudicators.get('adjudicators').map(function (a) {
    if ((0, _paths4.eventScoresByAdjudicatorAreLoading)(state, currentEventWithAdjudicators.get('id'), a.get('id'))) {
      return;
    }

    var scores = (0, _paths4.eventScoresByAdjudicator)(state, currentEventWithAdjudicators.get('id'), a.get('id')).map(function (score_ids, pid) {
      return {
        person: pid,
        competitor: state.getIn(['feiseanna', 'persons', fid, pid, 'competitor']),
        scores: score_ids.toJS().map(function (score_id) {
          return (0, _paths4.getScore)(state, score_id).toJS();
        })
      };
    }).toArray();

    var sortedScores = scores.sort(function (a, b) {
      return personTotal(a) - personTotal(b);
    }).reverse();
    return sortedScores;
  });

  var recalledEvents = (0, _paths.eventsWithStatus)(state, fid, 'RCL');

  var placedEvents = (0, _paths.eventsWithStatus)(state, fid, 'RES');

  return {
    loading: false,
    results: {
      recall: recalledEvents, // needed on page to show recalled events
      placements: placedEvents, // needed on announce page to show placed events
      currentEventWithAdjudicators: currentEventWithAdjudicators,
      eventMedalRounds: eventMedalRounds,
      participants: participants,
      scoreSheets: scoreSheets && scoreSheets.toJS(),
      persons: participants && participants.filter(function (p) {
        return p.getIn(['reg', 'placed']);
      }).toJS()
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/announce/mapStateToController.js
// module id = 540
// module chunks = 0